import { useQuery } from "@tanstack/react-query";
import { ProviderGroupControllerApi } from "../services";
import { getConfigObject } from "../utils/utils";

interface GetProviderNameProps {
  xTENANTID: string | undefined;
}

export function useGetProivderGroupName({ xTENANTID }: GetProviderNameProps) {
  return useQuery({
    queryKey: ["provider-group-name", xTENANTID],
    queryFn: () =>
      new ProviderGroupControllerApi(getConfigObject()).getProviderGroupName(
        xTENANTID
      ),
    enabled: !!xTENANTID,
    retry:1
  });
}
